import { render } from "./ComplementacaoView.vue?vue&type=template&id=00c2695c&scoped=true"
import script from "./ComplementacaoView.vue?vue&type=script&lang=js"
export * from "./ComplementacaoView.vue?vue&type=script&lang=js"

import "./ComplementacaoView.vue?vue&type=style&index=0&id=00c2695c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c2695c"]])

export default __exports__